module.exports = __webpack_public_path__ + "media/50.db8b4ed5.mp3";